
































































import {
  Vue, Component, Prop, Watch, Mixins, Emit, PropSync,
} from 'vue-property-decorator'
import dayjs from 'dayjs'
import { clone, equals } from 'ramda'
import {
  update, field, collection, get, query, where, set, add, value,
} from 'typesaurus'
import {
  getModule,
} from 'vuex-module-decorators'
import md5 from 'md5'
import firebase from 'firebase'
import MainMixin from '../../mixins/MainMixin'
import EventBus from '../../event-bus'
import TaskStore from '../../store/modules/tasks'
import { db } from '../../firebase/init'
import { TaskType, CommentType, CustomerType } from '../../types'
import SingleCustomer from './SingleCustomer.vue'

function isEmail(text:string) {
  return /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/.test(text)
}

@Component({
  components: {
    SingleCustomer,
  },
})
export default class FindCustomer extends Mixins(MainMixin) {
  @Prop() data!:CustomerType

  @Prop({ default: false }) canUpdate!:boolean

  @Prop({ default: true }) canSearchById!:boolean

  // @Prop({ default: [] }) actions!:any[]

  searchInput:string = ''

  hasCheck = false

  originalData = {}

  equals = equals

  get searchIsEmail() {
    if (!this.canSearchById) return true
    return isEmail(this.searchInput)
  }

  get profile() {
    if (this.data) {
      if (this.data.profile) return this.data.profile
      const hash = md5(this.data.email)
      return `https://www.gravatar.com/avatar/${hash}?d=identicon&s=400`
    } return null
  }

  showMap = { cannotFindCustomer: false }

  customerData:any = {}

  loading = false

  $unbind:any

  updatedSearch() {
    if (this.customerData && this.customerData.id) this.$unbind('customerData')
    this.showMap.cannotFindCustomer = false
    this.customerData = {}
  }

  get customer():CustomerType|null {
    if (Array.isArray(this.customerData) && this.customerData.length > 0 && this.customerData[0].id) {
      return this.customerData[0]
    } if (typeof this.customerData === 'object' && this.customerData !== null && this.customerData.id) return this.customerData
    return null
  }

  @Watch('customer')
  customerUpdated(cust:CustomerType|null) {
    console.log('customer updated')
    this.$emit('update:value', cust)
  }

  async bindCustomer() {
    this.loading = true
    const search = this.searchInput.trim().toLowerCase()
    console.log('searching for ', search)
    let result
    if (!this.searchIsEmail) {
      result = await this.$bind('customerData', db.collection('customers').doc(`f${search}`))
      if (!result) this.showMap = { cannotFindCustomer: true }
    } else {
      result = await this.$bind('customerData', db.collection('customers').where('email', '==', search))
      if (result && result.length === 0) this.showMap = { cannotFindCustomer: true }
    }
    console.log('result is: ', result)
    this.loading = false
  }

  // async addComment() {
  //   this.loading = true
  //   console.log('Adding Comment: ', this.newComment)
  //   const comment:CommentType = { user: this.$store.getters.uid, comment: this.newComment, created: new Date() }
  //   const result = await update(Tasks, this.id, [field('comments', value('arrayUnion', [comment]))])
  //   console.log('result is: ', result)
  //   this.newComment = ''
  //   this.$toast.success('Comment Added!')
  //   this.loading = false
  // }
}

